import React, { useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import CampaignDashboardView from 'views/Campaign/Dashboard';
import CampaignService from 'api/Campaign';
import ParticipantService from 'api/Participant';
import { useDelete, useFetch, useFetchTableData } from 'hooks';
import SettingsActions from 'store/reducers/Settings';
import { isCustomerAdmin } from 'utils';

const CampaignDashboard = ( {
  parentPath, userRoles, toggleLoading, toggleErrorAlert, user,
} ) => {
  const [dataSubmitted, setDataSubmitted] = useState( new Date().valueOf() );
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    if(!isMounted) setIsMounted(true)
    return () => setIsMounted(false)
  }, [])
  const [fetchData, data, dataLoading] = useFetchTableData( {
    promise: CampaignService.getCampaigns,
    toggleErrorAlert,
    deps: [dataSubmitted],
  } );

  const [participants, participantsLoading] = useFetch( {
    initialState: [],
    format: ( dataToFormat ) => _.map( [dataToFormat.userOwner, ...dataToFormat.data],
      ( item ) => ( {
        id: item.id,
        name: `${item.firstName || ''} ${item.lastName || ''}`,
      } ) ),
    promise: () => ParticipantService.getParticipants( { limit: -1 } ),
    conditional: !!userRoles && isCustomerAdmin( userRoles ),
    deps: [userRoles],
  } );

  const reloadData = useCallback( () => {
    setDataSubmitted( new Date().valueOf() );
  }, [] );

  const deleteEntity = useDelete( {
    promise: CampaignService.deleteCampaign,
    callback: reloadData,
    toggleLoading,
    toggleErrorAlert,
  } );

  return (
    <CampaignDashboardView
      data={data}
      participants={participants}
      participantsLoading={participantsLoading}
      userRoles={userRoles}
      parentPath={parentPath}
      isLoading={dataLoading && !isMounted}
      onFetchData={fetchData}
      onDelete={deleteEntity}
      userData={user}
    />
  );
};

const mapStateToProps = ( { user } ) => ( {
  userRoles: user.roles,
  user,
} );

const mapDispatchToProps = ( {
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( mapStateToProps, mapDispatchToProps )( CampaignDashboard );
